import OrdersContainer from '@components/containers/orders';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const Orders: FC = () => (
    <AppLayout>
        <OrdersContainer />
    </AppLayout>
);

export default Orders;
